import * as React from 'react';
import { Redirect } from 'react-router-dom';
import {
	signInRedirectCallback,
	processSignInRedirectCallback,
	UserManagerState,
} from 'servicesCommon/userManager';
import { Spin } from 'components/antd';

export interface LoginCallbackProps {}

export interface LoginCallbackState {
	returnUrl: string | null;
}

class LoginCallback extends React.Component<LoginCallbackProps, LoginCallbackState> {
	constructor(props: LoginCallbackProps) {
		super(props);
		this.state = {
			returnUrl: null,
		};
	}

	get isClientsEnv() {
		return process.env.REACT_APP_NAME === 'clients';
	}

	componentDidMount() {
		signInRedirectCallback()
			.then(processSignInRedirectCallback)
			.then(state => {
				let returnUrl = (state as UserManagerState).returnUrl || '/';
				if (this.isClientsEnv && returnUrl === '/') {
					returnUrl = '/userProfile';
				}
				this.setState({
					returnUrl,
				});
			})
			.catch(error => {
				throw new Error(`Error handling redirect callback: ${error.message}`);
			});
	}

	render() {
		if (this.state.returnUrl) {
			return <Redirect to={this.state.returnUrl} />;
		}
		return <Spin spinning={true} isLoginSpin />;
	}
}

export default LoginCallback;
